import "../../../assets/style/ActivityLog.css"
import LabelField from '../../../components/LabelField';
import { convertDate, convertWithoutTimezone } from "../../../utils/Util";

const ActivityLog = (props: any) => {
    const data = [...props.data].sort((a: any, b: any) => {
        const itemA = a?.date;
        const itemB = b?.date;
        return itemA < itemB ? 1 : -1;
    });

    return (
        <>
            <LabelField name='Activity Log'></LabelField>
            <div className="logContainer">  
                {data.map((each: any) => {
                    return each && (
                        <div key={each.id} className="custom-div">
                            <p className="log-text" dangerouslySetInnerHTML={{ __html: each.log || '' }}></p>
                            <p className="date-name-text">{convertDate(convertWithoutTimezone(each.date))} - {each.name}</p>
                        </div>
                    )
                })}
            </div>
        </>
    );
}


export default ActivityLog;